export function currentYear() {
    let d = new Date();
    d.setDate(d.getDate() - 180);
    return d.getFullYear();
}

export function buckeyePickemAge() {
    return currentYear() - 2000;
}